const BROCHURE_URL =
  '/assets/brochure/V_Square_Renewables_Broucher_2.0.pdf';

export const downloadBrochure = async () => {
  try {
    const response = await fetch(BROCHURE_URL, { cache: 'force-cache' });

    if (!response.ok) {
      throw new Error(`Failed to fetch brochure: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'V-Square-Renewables-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading brochure:', error);
    window.open(BROCHURE_URL, '_blank', 'noopener,noreferrer');
  }
};

export default BROCHURE_URL;
